import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { creditApi } from "@/lib/credit.api";
import { getApiErrorCode } from "@/lib/api-error";
import { queryKeys } from "@/lib/query-keys";

const ERROR_MESSAGES: Record<string, string> = {
  INVALID_AMOUNT: "Le montant doit être supérieur à zéro.",
  REFUND_EXCEEDS_LOT_BALANCE: "Le montant dépasse le solde restant de ce lot.",
  CREDIT_LOT_ALREADY_CONVERTED: "Ce lot a déjà été converti en épargne, il ne peut plus être remboursé.",
  CREDIT_LOT_NOT_FOUND: "Lot de crédit introuvable.",
};

export function useRefundCreditLotMutation(partyId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ lotId, amount }: { lotId: number; amount: number }) =>
      creditApi.refund(lotId, amount).then((r) => r.data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.credits(partyId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.creditLots(partyId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.creditLotEntries(variables.lotId) });
      toast.success("Remboursement enregistré.");
    },
    onError: (error) => {
      const code = getApiErrorCode(error);
      toast.error((code && ERROR_MESSAGES[code]) ?? "Erreur lors du remboursement.");
    },
  });
}
